
import { save, getExam, addCard } from '@/api/chunjie'
import cookie from 'vux/src/tools/cookie/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import pic1 from '../../assets/chunjie/fokas/pic1.png'
import pic2 from '../../assets/chunjie/fokas/pic2.png'
import pic3 from '../../assets/chunjie/fokas/pic3.png'
import pic4 from '../../assets/chunjie/fokas/pic4.png'
import pic5 from '../../assets/chunjie/fokas/pic5.png'
import pic6 from '../../assets/chunjie/fokas/pic6.png'
import pic7 from '../../assets/chunjie/fokas/pic7.png'
import pic8 from '../../assets/chunjie/fokas/pic8.png'
import pic9 from '../../assets/chunjie/fokas/pic9.png'
import pic10 from '../../assets/chunjie/fokas/pic10.png'
import pic11 from '../../assets/chunjie/fokas/pic11.png'
import pic12 from '../../assets/chunjie/fokas/pic12.png'
import { setTimeout } from 'timers'
import { getview } from '@/api/jfhl.js'
import { nowInDateBetwen } from '@/libs/utils'
export default {
directives: {
TransferDom
},
components: {
XDialog
},
name: '',
data () {
return {
active: 0, // 当前题数
btnPre: '上一题',
btnNext: '下一题',
btnFinal: '提交',
pics: [
pic1,
pic2,
pic3,
pic4,
pic5,
pic6,
pic7,
pic8,
pic9,
pic10,
pic11,
pic12
],
rule: false,
result: false,
resultText: '',
resultType: '',
paperInfoid: '',
partyid: '1385',

examList: [],
subjectid: [],
useroption: [],
msg: '',
showErrorList: false,
errorList: [],
showfokas: false,
fokasType: '',
isadd: true
}
},
created () {
this.view()
},
watch: {
useroption (newValue, oldValue) {

this.useroption = newValue
console.log(this.useroption)
}
},
computed: {
userid () {
return this.$store.state.user.userid
},
accountid () {
return this.$store.state.user.accountid
}
},
methods: {

view () {
let _this = this
getview({
id: this.partyid
}).then(res => {
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
let timer = nowInDateBetwen(
res.obj.signstartdate,
res.obj.signenddate
)
if (timer == 0) {
this.$vux.alert.show({
content:
'活动还未开始,敬请期待' + '</br>',
onHide () {
_this.$router.push({ name: 'page_home' })
}
})
} else if (timer == -1) {
this.$vux.alert.show({
content: '活动已结束',
onHide () {
_this.$router.push({ name: 'page_home' })
}
})
} else {
this.getExamNow()
}
})
},
answerPre () {
this.active--
},

answer () {
let _this = this
if (this.active + 1 >= this.examList.length && this.useroption[this.active]) {
save({
paperInfoid: this.paperInfoid,
subjectid: this.subjectid.join(';'),
useroption: this.useroption.join(';'),
openid: this.accountid
}).then(data => {
if (data.obj.ISTRUE == 1) {
this.result = true
this.resultType = 'success'
} else {
this.result = true
this.resultType = 'fail'
let wt = data.obj.ERRORLIST.length
this.errorList = data.obj.ERRORLIST
if (data.obj.ANSWERNUM === 0) {
this.resultText = '答题次数用完了，明天再来吧'
}
}
this.subjectid = []
})
} else {
if (!this.useroption[this.active]) {
console.log(this.active)
this.$vux.toast.text('请选择答案')
return false
}
this.active++
}
},
getExamNow () {
let _this = this
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.examList = []
this.msg = '您今天的两次答题机会已用完<br>请明天再来'
return false
}
this.examList = data.obj.SUBJECTLIST
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
console.log(this.subjectid)
})
},

getCard () {
if (!this.showfokas) {
let _this = this
console.log(this.isadd)
if (!this.isadd) {
this.$vux.toast.text('请勿重复点击')
return false
} else {
_this.isadd = false
addCard({
openid: this.accountid,
baseid: this.paperInfoid
}).then(data => {
this.showfokas = true
this.fokasType = this.pics[parseInt(data.returnValue.type) - 1]
setTimeout(() => {
this.reset()
}, 3000)
})
}
}
},
again () {
this.reset()
},
reset () {
this.result = false
this.showfokas = false
this.active = 0
this.useroption = []
this.subjectid = []
this.getExamNow()
setTimeout(() => {
this.isadd = true
}, 3000)
}
}
}
